<template>
  <div class="modal-mask" @click.self="cancel">
    <div class="modal">
      <div class="head">
        <h4>{{ mode==='add' ? '지사 추가' : '지사 수정' }}</h4>
        <div class="head-btns">
          <button class="primary" :disabled="busy" @click="save">저장</button>
          <button class="ghost" @click="cancel">취소</button>
        </div>
      </div>

      <!-- 센터명 : 비활성 + 검색(센터 검색). 추가 시 필수. -->
      <div class="row">
        <label>센터명</label>
        <input :value="centerName" type="text" disabled placeholder="센터 검색" />
        <button class="srch" @click="centerSearchOpen=true">검색</button>
      </div>

      <!-- 지사명 : 에디트 -->
      <div class="row">
        <label>지사명</label>
        <input v-model="branchName" type="text" placeholder="지사명" />
      </div>

      <!-- 지사장 : 비활성 + 검색(회원 검색) -->
      <div class="row">
        <label>지사장</label>
        <input :value="leaderName" type="text" disabled placeholder="지사장(회원 검색)" />
        <button class="srch" @click="memberSearchOpen=true">검색</button>
      </div>

      <!-- 사용여부 : 라디오 -->
      <div class="row">
        <label>사용여부</label>
        <label class="radio"><input type="radio" value="Y" v-model="useYn" /> Y</label>
        <label class="radio"><input type="radio" value="N" v-model="useYn" /> N</label>
      </div>

      <p v-if="message" class="error">{{ message }}</p>
    </div>

    <SettlementCenterSearchDialog v-if="centerSearchOpen" @select="onPickCenter" @close="centerSearchOpen=false" />
    <SettlementMemberSearchDialog v-if="memberSearchOpen" @select="onPickMember" @close="memberSearchOpen=false" />
  </div>
</template>

<script>
import api from '../api';
import SettlementCenterSearchDialog from './SettlementCenterSearchDialog.vue';
import SettlementMemberSearchDialog from './SettlementMemberSearchDialog.vue';

export default {
  name: 'BranchFormDialog',
  components: { SettlementCenterSearchDialog, SettlementMemberSearchDialog },
  props: {
    mode: { type: String, default: 'add' },
    branch: { type: Object, default: null }
  },
  data() {
    return {
      id: this.branch ? this.branch.id : null,
      centerId: this.branch ? this.branch.centerId : null,
      centerName: this.branch ? (this.branch.centerName || '') : '',
      branchName: this.branch ? (this.branch.branchName || '') : '',
      leaderCustomerId: this.branch ? this.branch.leaderCustomerId : null,
      leaderName: this.branch ? (this.branch.leaderName || '') : '',
      useYn: this.branch ? (this.branch.useYn || 'Y') : 'Y',
      centerSearchOpen: false, memberSearchOpen: false,
      busy: false, message: ''
    };
  },
  methods: {
    onPickCenter(c) { this.centerId = c.id; this.centerName = c.centerName; this.centerSearchOpen = false; },
    onPickMember(m) { this.leaderCustomerId = m.id; this.leaderName = m.name; this.memberSearchOpen = false; },
    async save() {
      this.message = '';
      if (!this.centerId) { this.message = '센터를 먼저 선택하세요.'; return; }
      if (!this.branchName || !this.branchName.trim()) { this.message = '지사명을 입력하세요.'; return; }
      this.busy = true;
      try {
        const payload = { id: this.id, centerId: this.centerId, branchName: this.branchName.trim(), leaderCustomerId: this.leaderCustomerId, useYn: this.useYn };
        const res = this.mode === 'add' ? await api.branchAdminAdd(payload) : await api.branchAdminUpdate(payload);
        const data = res.data || {};
        if (data.success === false) { this.message = res.message || '저장할 수 없습니다.'; return; }
        this.$emit('saved');
      } catch (e) { this.message = e.message; }
      finally { this.busy = false; }
    },
    cancel() { this.$emit('close'); }
  }
};
</script>

<style scoped>
.modal-mask { position: fixed; inset: 0; background: rgba(0,0,0,.4); display: flex; align-items: center; justify-content: center; z-index: 75; }
.modal { background: #fff; padding: 20px 22px; border-radius: 8px; width: 460px; max-width: 94vw; }
.head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px; }
.head h4 { margin: 0; }
.head-btns button { padding: 7px 14px; border-radius: 6px; cursor: pointer; border: 1px solid #ccc; margin-left: 6px; }
.head-btns .primary { background: #2f6fed; color: #fff; border-color: #2f6fed; }
.head-btns .ghost { background: #f5f5f5; }
.row { display: flex; align-items: center; gap: 8px; margin: 10px 0; }
.row label { width: 60px; font-size: 13px; color: #555; }
.row input { flex: 1; padding: 8px; border: 1px solid #d0d5dd; border-radius: 6px; }
.row input:disabled { background: #f2f4f7; color: #667085; }
.srch { padding: 7px 12px; border: 1px solid #2f6fed; background: #eef4ff; color: #2f5fd0; border-radius: 6px; cursor: pointer; font-size: 12px; }
.row .radio { width: auto; display: inline-flex; align-items: center; gap: 4px; font-size: 13px; color: #333; }
.error { color: #d93636; font-size: 13px; margin: 8px 0 0; }
</style>
